export enum AttedanceChartSort{
    UNKNOWN, 
    DATEASC,
    DATEDESC,
    ATTENDEDASC,
    ATTENDEDDESC,
    DNAASC,
    DNADESC,
}